import { useFormContext } from 'react-hook-form';

import { FormCheckbox, FormField, Label } from '@/_components';

import { isStatusTrue } from '../../../_schemas/status-input/schema';

export function StatusInput({ isEditable }: { isEditable?: boolean }) {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name="status"
      render={({ field }) => (
        <div className="pb-1.5">
          <Label className="mb-1.5 -translate-y-2 text-[11px]">Status</Label>
          <FormCheckbox
            disabled={!isEditable}
            checked={isStatusTrue(field.value)}
            onChange={(e) => {
              field.onChange(
                e.target.checked ? { name: 'Active', value: 'active' } : { name: 'Inactive', value: 'inactive' }
              );
            }}
            label={field.value.name}
          />
        </div>
      )}
    />
  );
}
